export const QUERY__PROMOCODES = 'promocodes';
